var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-auto",staticStyle:{"height":"80px","width":"80px"}},[(!_vm.loading)?_c('v-progress-circular',{attrs:{"value":100 * _vm.value,"size":"80","width":"12","rotate":"90","color":_vm.color}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.shownValue))])]):_c('LargeSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }